import { ShowMoreRecommendations } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { ShowMoreCardsAction } from '../../home/actions/ShowMoreCardsAction';
import { ChannelTypes } from '../../home/types/ChannelTypes';

export interface ShowMoreRecommendationsAction extends ShowMoreCardsAction {
}

export function showMoreRecommendations(numCardsToShow: number, channelType: ChannelTypes): ShowMoreRecommendationsAction {
  return {
    type: ShowMoreRecommendations,
    numCardsToShow,
    channelType
  };
}

export const isShowMoreRecommendationsAction = isActionFactory<ShowMoreRecommendationsAction>(ShowMoreRecommendations);
